export const getOptionsFromTranslation = (translation: string) =>
    translation.split('\n').reduce<Record<string, string>>((map, entry) => {
        const match = entry.trim().match(/\s*\[(.+)\]\((.+)\)\s*/);
        if (match && match.length === 3) {
            map[match[1]] = match[2];
        }
        return map;
    }, {});
